<template>
  <b-modal
    size="xl"
    ok-title="Continue"
    :title="this.title"
    title-tag="h5"
    cancel-title="Cancel"
    cancel-variant="outline-primary"
    id="idRejectTprModal"
    :ok-disabled="rejectReasons.length === 0"
    @ok="onOk"
    @hidden="onHidden"
  >
    <div class="padding">
      <b-row>Please provide a reason for rejection.</b-row>
      <b-row>
        <label for="idTreatmentDetailsProcedure">Rejection Reason</label>
        <b-form-select
        multiple
          size="sm"
          required
          id="idRejectReason"
          v-model="rejectReasons"
          :options="rejectReasonOptions"
        >
        </b-form-select>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      rejectReasons: [],
      rejectReasonOptions: []
    };
  },
  props: ["tprId", "applicationType"],
  created() {
    if(!this.applicationType) return
    switch (this.applicationType) {
      case "TTK":
        this.rejectReasonOptions = [
          "Ankle slice increment/spacing violation",
          "Bilat in one exam",
          "Failed motion check",
          "Femur not optimal length for planning",
          "Field-of-view (FOV) violation",
          "File compression issue",
          "Hip slice increment/spacing violation",
          "Image blur",
          "Knee slice increment/spacing violation",
          "Missing region(s) - ankle not included",
          "Missing region(s) - hip not included",
          "Missing region(s) - knee not included",
          "Motion rod not in view",
          "Open brace error",
          "Partial knee / PF already present",
          "Severely rotated",
          "Tibia not optimal length for planning",
          "Unmatched reference frames"
        ];
        break;
      case "TH":
        this.rejectReasonOptions = [
          "1 hip, 1 knee",
          "ASIS points missing - full pelvis not in view",
          "Existing THA implant",
          "Femur not optimal length for planning",
          "Fused anatomy",
          "Field-of-view (FOV) violation",
          "File compression issue",
          "Hip slice increment/spacing violation",
          "Incorrect naming convention",
          "Incorrect # of files/images",
          "Knee slice increment/spacing violation",
          "Missing region(s) - pelvis not included",
          "Missing region(s) - knees not included",
          "No contrast",
          "Open brace error",
          "Resolution matrix less than 512x512 or not square",
          "Scans broken up in planning laptop",
          "Special characters in file name(s)",
          "Unmatched reference frames"
        ];
        break;
      case "MCKPK":
        this.rejectReasonOptions = [
          "Ankle slice increment/spacing violation",
          "Bilat in one exam",
          "Failed motion check",
          "Femur not optimal length for planning",
          "Field-of-view (FOV) violation",
          "File compression issue",
          "Hip slice increment/spacing violation",
          "Image blur",
          "Knee slice increment/spacing violation",
          "Missing region(s) - ankle not included",
          "Missing region(s) - hip not included",
          "Missing region(s) - knee not included",
          "Motion rod not in view",
          "Open brace error",
          "Partial knee / PF already present",
          "Severely rotated",
          "Tibia not optimal length for planning",
          "Unmatched reference frames"
        ];
        break;
      default:
        this.$root.$emit("showAlert", {
          type: "error",
          msg: "Unknown Application Type " + this.applicationType
        });
        break;
    }
  },
  computed: {
    title(){
      return `You are about to reject Treatment Plan Request ${this.tprId}`
    }
  },
  methods: {
    onOk() {
      const rejectReason = this.rejectReasons.join(", ")
      this.$emit("tprRejected", rejectReason);
    },
    onHidden() {
      this.rejectReasons = [];
    }
  }
};
</script>

<style scoped>
.padding {
  padding: 1rem 3rem;
}
.row {
  margin-top: 1rem;
}
</style>